import React from 'react';

import { Image } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BuilderLocalizedRichText from '~/shared/components/BuilderLocalizedRichText';
import BuilderLocalizedText from '~/shared/components/BuilderLocalizedText';

const Container = styled.div`
  max-height: inherit;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0;

  picture {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  img {
    min-height: 0;
    margin: 0 auto;
  }
`;

const TextContainer = styled.div`
  padding: 20px 0 30px 0;
  line-height: 1.2;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 22px;
  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor};
    `}
`;

const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  max-width: 348px;
  margin: 0 auto;
  padding-top: 8px;

  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor};
    `}
`;

const BuilderFullWidthImageWithCaption = (props) => {
  const { title, description, image, textColor } = props;
  const hasText = title || description;

  return (
    <Container data-builder-component-type="storytelling_full_width_image_and_caption">
      <Image src={image} alt="" />
      {hasText && (
        <TextContainer>
          {title && (
            <Title textColor={textColor}>
              <BuilderLocalizedText text={title} />
            </Title>
          )}
          {description && (
            <Description textColor={textColor}>
              <BuilderLocalizedRichText text={description} />
            </Description>
          )}
        </TextContainer>
      )}
    </Container>
  );
};

BuilderFullWidthImageWithCaption.propTypes = {
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  image: PropTypes.string,
  textColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default BuilderFullWidthImageWithCaption;
